import { useEffect, useState } from 'react';
import type { EventOccurrence } from '../../shared/contracts';
import { api } from '../api';
import { formatEventRange } from '../format';

export function SubscriptionPreview({ calendarIds }: { calendarIds: string[] }) {
  const [state, setState] = useState<{
    events: EventOccurrence[];
    loading: boolean;
    error: boolean;
  }>({ events: [], loading: true, error: false });
  const selection = [...calendarIds].sort().join(',');
  useEffect(() => {
    let current = true;
    if (!selection) {
      setState({ events: [], loading: false, error: false });
      return;
    }
    setState({ events: [], loading: true, error: false });
    const from = new Date();
    const to = new Date(from.getTime() + 30 * 86400000);
    void api
      .events(from, to, selection.split(','))
      .then(({ events }) => {
        if (current)
          setState({
            events: events.filter((event) => event.status !== 'draft'),
            loading: false,
            error: false,
          });
      })
      .catch(() => {
        if (current) setState({ events: [], loading: false, error: true });
      });
    return () => {
      current = false;
    };
  }, [selection]);
  return (
    <section aria-label="Subscription preview" aria-live="polite">
      <h3>Coming up in your feed</h3>
      <p>Preview of the next 30 days. Your subscription also includes other published dates.</p>
      {!selection ? (
        <p>Choose a calendar to see upcoming events.</p>
      ) : state.loading ? (
        <p>Loading preview…</p>
      ) : state.error ? (
        <p>Preview is unavailable. You can still create your feed.</p>
      ) : !state.events.length ? (
        <p>No events in the next 30 days.</p>
      ) : (
        <ul>
          {state.events.slice(0, 5).map((event) => (
            <li key={event.occurrenceId}>
              <b>{event.title}</b>
              {event.status === 'cancelled' ? ' (cancelled)' : ''}
              <span>
                {' '}
                · {formatEventRange(event)} · {event.calendarName}
              </span>
            </li>
          ))}
        </ul>
      )}
      {state.events.length > 5 && <p>And {state.events.length - 5} more in the next 30 days.</p>}
    </section>
  );
}
